module.exports = {
    CTX_ID: 'dashboard',
    EVENT_TYPE_PRESENTED_VALUE: '1',
    EVENT_TYPE_PRESENTED: 'Presented',
    GET_INBOX_INSIGHTS: 'getInboxInsights',
    GET_INSIGHTS_CTX_ID: 'sampleNew',
    GET_INSIGHTS: 'getInsights',
    INIT_PERSONETICS: 'initPersonetics',
    PROTOCOL_VERSION: '2.5',
    SELECTED_RADIO_ALL_INSIGHTS: 'TODOS',
    SELECTED_RADIO_UNREAD_INSIGHTS: 'SIN LEER',
    SEND_EVENT: 'sendEvents',
};